import React from 'react';
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ParticipantFiltersProps {
  searchQuery: string;
  statusFilter: string;
  onSearchChange: (value: string) => void;
  onStatusFilterChange: (value: string) => void;
}

export function ParticipantFilters({
  searchQuery,
  statusFilter,
  onSearchChange,
  onStatusFilterChange
}: ParticipantFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 mb-4">
      <div className="relative w-full sm:w-64">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-500" />
        <Input 
          type="text" 
          placeholder="Search participants..." 
          className="pl-8 h-9"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      
      <Select value={statusFilter} onValueChange={onStatusFilterChange}>
        <SelectTrigger className="w-full sm:w-40 h-9">
          <SelectValue placeholder="Filter by status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Statuses</SelectItem>
          <SelectItem value="signed_up">Signed Up</SelectItem>
          <SelectItem value="attended">Attended</SelectItem>
          <SelectItem value="no_show">No Show</SelectItem>
          <SelectItem value="opt_out">Opted Out</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
